const specificOrderState = [];

module.exports = function specificOrderReducer(state = specificOrderState, action) {
	switch (action.type) {
		case "LOAD_SPECIFIC_ORDER":
			return action.payload;

		case "UNLOAD_SPECIFIC_ORDER":
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/specificOrder.js